import React, { Component } from 'react'

class DateTime extends Component {
  constructor(props) {
    super(props);

    this.state = { datetime: new Date() }
    this.setTime = this.setTime.bind(this);

    this.updateDate = false;
  }

  componentDidMount() {
    this.updateDate = true;
    setInterval(this.setTime, 1000);
  }
  componentWillUnmount() {
    this.updateDate = false;
  }

  setTime() {
    if (this.updateDate) {
      this.setState({ datetime: new Date() });
    }
  }

  render() {
    const now = this.state.datetime;
    const hour = (('0').concat(now.getHours())).slice(-2);
    const minute = (('0').concat(now.getMinutes())).slice(-2);

    const day = (('0').concat(now.getDate())).slice(-2);
    const month = (('0').concat((now.getMonth() + 1))).slice(-2);
    const year = now.getFullYear();

    return (
      <div>
        <i className="calendar icon">&nbsp; </i>
        {`${day}-${month}-${year}`}&nbsp;&nbsp;
          <i className="wait icon">&nbsp;</i>
        {`${hour}:${minute}`}
      </div>)
  }

}

export default DateTime



// WEBPACK FOOTER //
// src/components/DateTime.jsx